import { useAssignmentUrl } from 'domain/shared/assignment';
import { SidebarStickyMenu, SummaryMenuItem } from 'framework/ui/menu';

const ViewAssignmentPageMenu = () => {
  const { getSingleEntityUrl } = useAssignmentUrl();

  return (
    <SidebarStickyMenu>
      <SummaryMenuItem linkUrl={getSingleEntityUrl()} />
    </SidebarStickyMenu>
  );
};

export default ViewAssignmentPageMenu;
